import React, {createContext, FC, useContext, useMemo} from 'react';
import {FeatureFlagSetup} from './types';

const FeatureFlagContext = createContext<FeatureFlagSetup>({
  mergedConfig: {},
} as FeatureFlagSetup);

const useFeatureFlagContextValue = () => {
  return useContext(FeatureFlagContext);
};

export const useMergedFeatureFlagConfig = () => {
  return useFeatureFlagContextValue().mergedConfig;
};

export const FeatureFlagProvider: FC<
  React.PropsWithChildren<FeatureFlagSetup>
> = ({children, mergedConfig}) => {
  const value = useMemo(() => ({mergedConfig}), [mergedConfig]);
  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
